// extracted by mini-css-extract-plugin
export default {"container":"index-module__container--MdU6e"};